/* Data v realitní sekci. Bez knihovny a bez `toLocaleString`.
 *
 * PROČ RUČNĚ: `toLocaleString` dává na různých strojích různý tvar, takže by
 * test měřil prostředí, ne kód (stejný důvod jako `kdyLidsky` na obrazovce
 * zájemců). Tvar je krátký schválně — v řádku časové osy jde o to, KDY se to
 * stalo, ne o přesnost na sekundu.
 */

const dvojciferne = (n) => String(n).padStart(2, "0");

function bezpecne(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** ISO → „12. 3. 2026". Nesmysl vrací prázdný řetězec, ne „Invalid Date". */
export function denLidsky(iso) {
  const d = bezpecne(iso);
  if (!d) return "";
  return `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
}

/** ISO → „12. 3. 2026 v 15:30". Pro prohlídky a zápisy v ose. */
export function denACas(iso) {
  const d = bezpecne(iso);
  if (!d) return "";
  return `${denLidsky(iso)} ${dvojciferne(d.getHours())}:${dvojciferne(d.getMinutes())}`;
}

/** ISO → „2026-03-12" do `<input type="date">`. Prázdné zůstane prázdné. */
export function proPole(iso) {
  const d = bezpecne(iso);
  if (!d) return "";
  return `${d.getFullYear()}-${dvojciferne(d.getMonth() + 1)}-${dvojciferne(d.getDate())}`;
}
